import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash';
import { MY_BETS } from '../../../consts/navigation';
import { FETCH_MY_BETS } from '../../../redux/BetsTables';
import { connect } from 'react-redux';
import Table from '../../Table/Table';
import { tablesHeaders } from '../../../consts/tablesConf';
import SingleRow from '../SingleRow';
import { vehicleTypes } from '../../../consts/vehicleTypes';

const MyBetsContainer = ({ fetchMyBets, totalCount, totalPages, handleShowOffer, myBets, isMobile, vehicleType, }) => {
  return (
    <Table
      whichFolder={MY_BETS}
      tableHeaders={tablesHeaders[vehicleType][MY_BETS]}
      fetchOffers={fetchMyBets}
      totalCount={totalCount}
      totalPages={totalPages}
      renderRow={SingleRow(isMobile, vehicleType)}
      onRowClick={handleShowOffer}
      items={myBets}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    myBets: get(state, ['bets', MY_BETS, 'data']),
    totalCount: get(state, ['bets', MY_BETS, 'total_count']),
    totalPages: get(state, ['bets', MY_BETS, 'total_pages']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { fetchMyBets: () => dispatch(FETCH_MY_BETS()), };
};


MyBetsContainer.propTypes = {
  handleShowOffer: PropTypes.func.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  isMobile: PropTypes.any.isRequired,
  fetchMyBets: PropTypes.func.isRequired,
  myBets: PropTypes.object.isRequired,
  totalPages: PropTypes.number,
  totalCount: PropTypes.number,
};

MyBetsContainer.defaultProps = {
  myBets: [],
  totalPages: 1,
  totalCount: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyBetsContainer);
